<template>
    <div>
        <el-tabs type="border-card" @tab-click="handleClick">
            <el-tab-pane label="基本信息">
                <div class="line">基本信息</div>
                <div class="info-box">
                    <el-row :gutter="10">
                        <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple"></div></el-col>
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                              <div class="grid-content bg-purple" >
                                <ul v-for="item in List" :key="item.index">
                                  <li class="LRstyle">
                                    <span >出差申请单号</span>
                                    <span>{{item.ApplyCode}}</span>
                                  </li>
                                  <li class="LRstyle">
                                    <span>出差开始时间</span>
                                    <span>{{item.ApplyStartDate}}</span>
                                  </li>
                                  <li class="LRstyle">
                                    <span>出差结束时间</span>
                                    <span>{{item.ApplyEndDate}}</span>
                                  </li>
                                  <li class="LRstyle">
                                    <span>出差目的</span>
                                    <span>{{item.ActionType}}</span>
                                  </li>
                                   <li class="LRstyle">
                                      <span >是否长差</span>
                                      <span>
                                          <el-radio v-model="LongApplyFor"  label="1" disabled>是</el-radio>
                                          <el-radio v-model="LongApplyFor"  label="2" disabled>否</el-radio>
                                      </span>
                                  </li>
                                  <li class="LRstyle">
                                    <span>预算</span>
                                    <span>{{item.Amount}}</span>
                                  </li>
                                  <li class="LRstyle">
                                    <span>国际出差</span>
                                    <span>{{item.International}}</span>
                                  </li>
                                  <li class="LRstyle">
                                    <span>备注</span>
                                    <span>{{item.Remark}}</span>
                                  </li>
                                </ul>
                              </div>
                            </el-col>
                        <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple-light"></div></el-col>
                    </el-row>
                </div>
                <div class="line">出行人<span>（{{Travellers.length}}）</span></div>
                <div class="info-box">
                    <el-row :gutter="10">
                        <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple"></div></el-col>
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="grid-content bg-purple">
                                  <ul v-for="item in Travellers" :key="item.index">
                                    <li class="LRstyle">
                                      <span >姓名</span>
                                      <span>{{item.Name}}</span>
                                    </li>
                                    <li class="LRstyle">
                                      <span>手机号</span>
                                      <span>{{item.Phone}}</span>
                                    </li>
                                    <li class="LRstyle">
                                      <span>邮箱</span>
                                      <span>{{item.Email}}</span>
                                    </li>
                                  </ul>
                                </div>
                            </el-col>
                        <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple-light"></div></el-col>
                    </el-row>
                </div>
                <div class="line">交通计划<span>（{{TrafficPlan.length}}）</span></div>
                <div class="info-box">
                    <el-row :gutter="10">
                        <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple"></div></el-col>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <div class="grid-content bg-purple">
                                <ul v-for="item in TrafficPlan" :key="item.index">
                                  <li class="LRstyle">
                                    <span >交通工具</span>
                                    <span>{{item.TrafficType}}</span>
                                  </li>
                                  <li class="LRstyle">
                                    <span>出发地</span>
                                    <span>{{item.StartCity}}</span>
                                  </li>
                                  <li class="LRstyle">
                                    <span>目的地</span>
                                    <span>{{item.EndCity}}</span>
                                  </li>
                                  <li class="LRstyle">
                                    <span>时间</span>
                                    <span>{{item.StartDate}}</span>
                                  </li>
                                </ul>
                            </div>
                            </el-col>
                        <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple-light"></div></el-col>
                    </el-row>
                </div>
                <div class="line">住宿计划<span>（{{HotelPlan.length}}）</span></div>
                <div class="info-box">
                    <el-row :gutter="10">
                        <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple"></div></el-col>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <div class="grid-content bg-purple" v-if="HotelPlan.length>0">
                              <ul v-for="item in HotelPlan" :key="item.index">
                                <li class="LRstyle">
                                  <span >城市</span>
                                  <span>{{item.City}}</span>
                                </li>
                                <li class="LRstyle">
                                  <span>入住时间</span>
                                  <span>{{item.StartDate}}</span>
                                </li>
                                <li class="LRstyle">
                                  <span>离开时间</span>
                                  <span>{{item.EndDate}}</span>
                                </li>
                              </ul>
                            </div>
                            </el-col>
                        <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple-light"></div></el-col>
                    </el-row>
                </div>
                <div class="line">附件信息<span>（{{fileRepertories.length}}）</span></div>
                <div class="info-box">
                    <el-row :gutter="10">
                        <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple"></div></el-col>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <div class="grid-content bg-purple" v-if="fileRepertories.length>0">
                               <span v-for="item in fileRepertories" :key="item.index">
                                  <img src="" v-lazy="item.url" alt="附件信息" class="fileRepertories">
                               </span>
                            </div>
                            </el-col>
                        <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple-light"></div></el-col>
                    </el-row>
                </div>
                <div class="line">历史审批记录</div>
                <div class="suggest-box info-box">
                    <el-row :gutter="10">
                        <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple"></div></el-col>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <div class="grid-content bg-purple">
                              <el-table :data="AuditHistory" style="width: 100%">
                                <el-table-column prop="UserName" label="操作人">
                                </el-table-column>
                                <el-table-column prop="FinishDate" label="操作时间">
                                </el-table-column>
                                <el-table-column prop="Status" label="状态">
                                </el-table-column>
                                <el-table-column prop="Suggestion" label="备注">
                                </el-table-column>
                              </el-table>
                            </div>
                            </el-col>
                        <el-col :xs="0" :sm="0" :md="0" :lg="0" :xl="0"><div class="grid-content bg-purple-light"></div></el-col>
                    </el-row>
                </div>

                <el-dialog
                title="提示"
                :visible.sync="centerDialogVisible"
                width="30%"
                center>
                <span>请填写审批意见！</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="centerDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
                </span>
                </el-dialog>
            </el-tab-pane>

            <el-tab-pane label="审批意见" @click="click()">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item class="label-suggest" label="填写审批意见" prop="suggest">
                        <el-input type="textarea" v-model="form.suggest"></el-input>
                    </el-form-item>
                    <el-form-item class="btn-suggest">
                        <el-button type="primary" :plain="true" @click="open">通过</el-button>
                        <el-button type="primary" :plain="true" @click="openVn" >退回</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <el-button type="text" @click="open2" class="goback" v-if="tabId !== 'tab-1'">
            <el-button type="info" class="go">通过</el-button>
            <el-button type="info" class="back">退回</el-button>
        </el-button>
    </div>
</template>
<script>
import { getApiURL } from "../config";
export default {
    data() {
        return {
            id: this.$route.query.id,
            List: [],
            ActionType: [],
            TrafficPlan: [],
            Travellers: [],
            HotelPlan: [],
            AuditHistory: [],
            fileRepertories: [],
            LongApplyFor: "1",
            tabId: "",
            activeIndex: "1",
            activeIndex2: "1",
            centerDialogVisible: false,
            form: {
                suggest: ""
            },
            message: ""
        };
    },
    methods: {
        // 通过
        open() {
            let email = localStorage.email;
            let suggest = '"' + this.form.suggest + '"',
                id = '"' + this.id + '"';
            let rootUrl = getApiURL("");
            this.$http({
                method: "post",
                dataType: "jsonp",
                url:
                    rootUrl +
                    '/process?req_data={"rx_token": "fasdfasdfasdfasdfasdfasdfasdfasdf","p_code": "RFCAIWU","user_id": ' +
                    email +
                    ',"encrypted": "1","data": {"ComType": "SubmitApply","FlowID": ' +
                    id +
                    ', "Suggestion": ' +
                    suggest +
                    "}}"
            }).then(res => {
                let Message = res.data.data.RetMessage;
            });
            this.$notify({
                title: "提示",
                message: "提交审批成功",
                position: "top-left"
            });
            setTimeout(() => {
                this.$router.push({ path: "/" });
            }, 1000);
        },
        //退回
        openVn() {
            let email = localStorage.email;
            let suggest = '"' + this.form.suggest + '"',
                id = '"' + this.id + '"';
            let rootUrl = getApiURL("");
            this.$http({
                method: "post",
                dataType: "jsonp",
                url:
                    rootUrl +
                    '/process?req_data={"rx_token": "fasdfasdfasdfasdfasdfasdfasdfasdf","p_code": "RFCAIWU","user_id": ' +
                    email +
                    ',"encrypted": "1","data": {"ComType": "ApplyReturn","FlowID": ' +
                    id +
                    ', "Suggestion": ' +
                    suggest +
                    "}}"
            }).then(res => {
                let Message = res.data.data.RetMessage;
            });
            this.$notify({
                title: "提示",
                message: "驳回审批成功",
                position: "top-left"
            });
            setTimeout(() => {
                this.$router.push({ path: "/" });
            }, 1000);
        },
        open2() {
            this.$confirm("请填写审批意见, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info"
            })
                .then(() => {
                    document.getElementById("tab-1").click();
                })
                .catch(() => {});
        },
        handleClick(tab, event) {
            let $this = this;
            $this.tabId = event.target.id;
        },
        getDetail() {
            let email = localStorage.email;
            let $this = this;
            let id = '"' + this.id + '"';

            let rootUrl = getApiURL("");
            this.$http({
                method: "post",
                dataType: "jsonp",
                url:
                    rootUrl +
                    '/process?req_data={"rx_token": "fasdfasdfasdfasdfasdfasdfasdfasdf","p_code": "RFCAIWU","user_id": ' +
                    email +
                    ',"encrypted": "1","data": {"ComType": "GetApplyDetails","FlowID": ' +
                    id +
                    ', "FlowTypeID": 2}}'
            })
                .then(function(res) {
                    let Data = res.data.data;
                    let obj = {},
                        list = new Array(obj);
                    obj["ActionType"] = Data.ActionType;
                    obj["Amount"] = Data.Amount;
                    obj["ApplyCode"] = Data.ApplyCode;
                    obj["ApplyEndDate"] = Data.ApplyEndDate;
                    obj["ApplyStartDate"] = Data.ApplyStartDate;
                    obj["International"] = Data.ActionType;
                    obj["Remark"] = Data.Remark;
                    obj["UserName"] = Data.UserName;
                    $this.List = list;
                    $this.TrafficPlan = res.data.data.TrafficPlan;
                    $this.Travellers = res.data.data.Travellers;
                    $this.HotelPlan = res.data.data.HotelPlan;
                    $this.fileRepertories = res.data.data.fileRepertories;
                    $this.LongApplyFor =
                        res.data.data.LongApplyFor == true ? "1" : "2";
                    $this.AuditHistory = res.data.data.AuditHistory;
                })
                .catch(function(res) {
                    $this.$router.push({ path: "*" });
                });
        }
    },
    created() {
        this.getDetail();
    },
    components: {
        // theButton
    }
};
</script>
<style>

</style>





// WEBPACK FOOTER //
// src/components/basicInformation.vue